import { TextValue } from '../_general';

export enum UserStatusEnum {
    NONE = 0,
    LOST = 1,
    DORMANT,
    STALLED,
    ON_TARGET,
    STATUS_HOLD,
}

export const userStatusText: { [key in UserStatusEnum]: string } = {
    [UserStatusEnum.NONE]: '',
    [UserStatusEnum.LOST]: 'Lost',
    [UserStatusEnum.DORMANT]: 'Dormant',
    [UserStatusEnum.STALLED]: 'Stalled',
    [UserStatusEnum.ON_TARGET]: 'On-Target',
    [UserStatusEnum.STATUS_HOLD]: 'Status Hold',
};

export const userStatuses: TextValue[] = [
    { text: userStatusText[UserStatusEnum.NONE], value: UserStatusEnum.NONE },
    { text: userStatusText[UserStatusEnum.LOST], value: UserStatusEnum.LOST },
    { text: userStatusText[UserStatusEnum.DORMANT], value: UserStatusEnum.DORMANT },
    { text: userStatusText[UserStatusEnum.STALLED], value: UserStatusEnum.STALLED },
    { text: userStatusText[UserStatusEnum.ON_TARGET], value: UserStatusEnum.ON_TARGET },
    { text: userStatusText[UserStatusEnum.STATUS_HOLD], value: UserStatusEnum.STATUS_HOLD },
];
